import ImageLink from 'domain/components/image/ImageLink';
import ChsAttachment from 'domain/types/ChsAttachment';

type RelationshipToPropertyProps = {
  cd: string | null;
  descr: string | null;
  attachments: ChsAttachment[];
};

export function RelationshipToProperty(props: RelationshipToPropertyProps) {
  if (props.attachments && props.attachments.length) {
    return (
      <>
        {props.descr || ''} |{' '}
        {props.attachments.map((a) => (
          <ImageLink key={a.filenet} data={a} />
        ))}
      </>
    );
  }
  return <>{props.descr || ''}</>;
}
